import { render, staticRenderFns } from "./DealsListItem.vue?vue&type=template&id=faa05aa2&"
import script from "./DealsListItem.vue?vue&type=script&lang=js&"
export * from "./DealsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports